import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const MontanaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='montana'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='MT_ZS'
				points='946.63 543.31 947.75 736.56 720.17 735.5 524.52 728.29 389.29 718.52 385.84 771.17 376.89 765.46 365.86 748.89 359.41 746.6 349.61 764.08 339.22 764.88 314.5 760.52 253.55 765.22 247.69 770.55 238.15 773.37 226.64 759.63 225.04 738.85 218.69 728.89 205.11 724.36 197.06 710.35 183.57 652.87 175.41 628.41 168.06 623.41 151.33 632.36 135.61 636.36 127.4 629.33 125.16 600.24 147.1 523.3 946.63 543.31'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'MT_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('MT_ZS')}
			/>
			<polygon
				id='MT_ZN'
				points='147.1 523.3 146.19 511.52 123.97 503.48 97.16 463.05 55.7 413.29 58.73 398.43 33.47 350.91 41.71 295.23 46.44 239.12 195.47 256.19 378.65 273.42 646.55 286.9 945.18 292.43 946.63 543.31 147.1 523.3'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'MT_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('MT_ZN')}
			/>
			<polygon
				points='320.6 537.06 320.71 541.38 325.26 541.38 320.78 544.05 320.88 548.38 318.01 545.7 313.53 548.38 316.23 544.05 313.36 541.38 317.9 541.38 320.6 537.06'
				className='shape'
			/>
			<rect x='325.21' y='543.31' width='81.71' height='20' fill='none' className='shape' />
			<path
				d='M331.03,544.18l-1.31,6.82h7.44l1.3-6.82h2l-3.08,16.18h-1.99l1.44-7.6h-7.44l-1.43,7.6h-1.99l3.08-16.18h1.99Z'
				className='shape'
			/>
			<path
				d='M351.73,559.69c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM349.53,550.03c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path d='M356.66,560.35l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M372.94,559.69c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM370.74,550.03c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M377.87,560.35l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M400.81,560.35c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM402.1,550.23c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='168.98 476.3 169.08 480.62 173.63 480.62 169.15 483.3 169.26 487.62 166.38 484.95 161.9 487.62 164.6 483.3 161.73 480.62 166.27 480.62 168.98 476.3'
				className='shape'
			/>
			<rect x='173.58' y='482.56' width='104.16' height='20' fill='none' className='shape' />
			<path
				d='M187.88,499.6l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.39h-.05c-.34,1.49-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.19-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M195.55,499.6l2.22-11.61h1.99l-2.22,11.61h-1.99ZM198.13,484.75c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M203.56,497.58c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M214.94,497.58c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M237.36,492.55c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM228.43,495.02c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M252.49,487.99l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.19.22-1.96l1.25-6.56h1.99l-1.23,6.47c-.12.65-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path d='M256.22,499.6l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M271.83,499.6c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM273.12,489.47c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='221.68 293.39 221.79 297.72 226.33 297.72 221.85 300.39 221.96 304.71 219.09 302.04 214.61 304.71 217.31 300.39 214.43 297.72 218.98 297.72 221.68 293.39'
				className='shape'
			/>
			<rect x='226.28' y='299.65' width='102.91' height='20' fill='none' className='shape' />
			<path
				d='M230.11,300.51h1.97l-1.49,7.87h.1c.56-.71,1.1-1.27,1.6-1.83l5.69-6.04h2.49l-6.81,6.96,4.15,9.22h-2.16l-3.54-7.94-1.93,1.8-1.18,6.14h-1.97l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M249.47,316.69c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM250.76,306.57c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M256.73,316.69l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M264.64,316.69l2.22-11.61h1.99l-2.22,11.61h-1.99ZM267.23,301.84c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M272.66,314.67c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M282.89,321.44l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.07,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM286.16,314.74c.51.4,1.27.64,2.22.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.23-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M307.41,316.03c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM305.2,306.37c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path d='M312.34,316.69l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M320.26,316.69l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<polygon
				points='578.83 648.46 578.94 652.78 583.48 652.78 579 655.45 579.11 659.78 576.24 657.1 571.76 659.78 574.46 655.45 571.58 652.78 576.13 652.78 578.83 648.46'
				className='shape'
			/>
			<rect x='583.43' y='654.71' width='88.36' height='20' fill='none' className='shape' />
			<path
				d='M587.21,655.8c.99-.2,2.15-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM586.44,670.14c.51.08,1.09.1,1.64.1,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM587.92,662.44h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.24Z'
				className='shape'
			/>
			<path
				d='M598.97,671.75l2.22-11.61h1.99l-2.22,11.61h-1.99ZM601.55,656.9c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M606.9,671.75l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M614.81,671.75l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M622.73,671.75l2.22-11.61h1.99l-2.22,11.61h-1.99ZM625.31,656.9c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M630.65,671.75l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M645.99,674.39c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM654.91,661.87c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M660.98,669.74c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<polygon
				points='397.08 413.2 397.19 417.52 401.73 417.52 397.25 420.19 397.36 424.52 394.49 421.84 390.01 424.52 392.71 420.19 389.83 417.52 394.38 417.52 397.08 413.2'
				className='shape'
			/>
			<rect x='401.68' y='419.45' width='126.11' height='20' fill='none' className='shape' />
			<path
				d='M414.34,435.8c-.94.37-2.66.85-4.56.85-2.28,0-4.06-.65-5.29-2.01-1.23-1.35-1.63-3.12-1.63-4.72,0-2.68,1.09-5.5,3.16-7.36,1.73-1.52,4.06-2.4,6.65-2.4,1.99,0,3.33.45,3.82.74l-.66,1.68c-.82-.42-1.94-.7-3.4-.7-1.9,0-3.66.71-5.01,1.97-1.51,1.41-2.43,3.73-2.43,5.92,0,3.12,1.57,5.19,5.16,5.19.96,0,1.87-.2,2.46-.46l.92-4.83h-3.27l.31-1.63h5.23l-1.46,7.77Z'
				className='shape'
			/>
			<path
				d='M419.76,436.49l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M438.05,435.83c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM435.85,426.17c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M450.67,436.49c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM451.96,426.37c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M463.14,421.77l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M477.82,420.32h8.21l-.33,1.7h-6.21l-1.04,5.46h5.72l-.33,1.69h-5.72l-1.38,7.33h-1.99l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M494.97,436.49c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM496.26,426.37c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M502.23,436.49l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M510.15,436.49l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M518.16,434.48c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<rect
				x='734.54'
				y='592.12'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M733.92,631.64l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M768.41,628.46c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='599.71'
				y='369.55'
				width='72.08'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M599.09,409.07l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M632.96,412.15l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
		</svg>
	);
};

MontanaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default MontanaMap;
